<template>
  <div class="record-wrap">
    <van-list class="refreshWrap" v-model="isRefresh" @load="onLoad" finished-text="没有更多了" :finished="finished">
      <ul class="repair-list">
        <li class="repair" v-for="(item, index) in dataList" :key="item.RepairID">
          <h3 class="title">{{item.RepairName}}</h3>
          <div class="info">
            <p class="state">
              <span v-if="item.State === 1" style="color:#f90;">待审批</span>
              <span v-if="item.State === 2" style="color:#ccc;">已撤销</span>
              <span v-if="item.State === 3" style="color:#f05a4a;">已拒绝</span>
              <span v-if="item.State === 4" style="color:#5cadff;">维修中</span>
              <span v-if="item.State === 5" style="color:#19be6b;">已完成</span>
            </p>
            <time>{{item.ModifiedByDate}}</time>
          </div>
          <van-divider></van-divider>
          <p class="see-btn">
            <span @click="goDetail(index)">
              <van-icon name="edit"></van-icon>
              <a href="javascript:;">查看</a>
            </span>
          </p>
        </li>
      </ul>
    </van-list>
    <SingleBottomBtn @clickBtn="createRepair">创建维修单</SingleBottomBtn>
  </div>
</template>
<script>

  import SingleBottomBtn from '@/components/SingleBottomBtn.vue'
  export default {
    name: 'RepairReportList',
    components: {
      SingleBottomBtn
    },
    data() {
      return {
        isRefresh: false,
        finished: false,
        dataList: [],
        totalItems: 0,
        pageIndex: 0,
        pageSize: 15,
      }
    },
    created() {

    },
    methods: {
      createRepair() {
        this.$router.push('/home/repairReportCreate')
      },
      goDetail(index) {

        let queryInfo = {
          info: JSON.stringify(this.dataList[index])
        }
        this.$router.push({path: '/home/repairReportDetail', query: queryInfo})
      },
      async getList() {
        var params = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        }
        let res = await this.xyapi.get(this.$store.state.apiPath + '/api/ApplyRepair/GetPage', params);
        if (res.success) {
          // 加载状态结束
          this.isRefresh = false;

          if (res.data.data) {
            this.totalItems = res.data.totalRecords
            this.dataList = this.dataList.concat(res.data.data)
          } else {
            this.finished = true;
          }
          if (this.dataList.length >= this.totalItems) {
            this.finished = true;
          }
        }

      },
      onLoad() {
        this.pageIndex++
        this.getList()
      }
    }
  }
</script>
<style lang="less" scoped>
  .record-wrap {
    .repair-list {
      font-size: 28px;
      .repair {
        background: #ffffff;
        margin-top: 20px;
        height: 242px;
        .title {
          font-size: 32px;
          padding: 16px 20px;
        }
        .info {
          display: flex;
          padding: 10px 20px;
          justify-content: space-between;
        }
        .see-btn {
          display: flex;
          justify-content: flex-end;
          padding: 0 20px;
          color: #f90;
          a {
            color: #f90;
            margin-left: 8px;
          }
        }
      }
    }
  }
</style>
